var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAim(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_254_8195)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 27.5C8.1075 27.5 2.5 21.8925 2.5 15C2.5 8.1075 8.1075 2.5 15 2.5C21.8925 2.5 27.5 8.1075 27.5 15C27.5 21.8925 21.8925 27.5 15 27.5ZM15 4.375C9.14125 4.375 4.375 9.14125 4.375 15C4.375 20.8588 9.14125 25.625 15 25.625C20.8588 25.625 25.625 20.8588 25.625 15C25.625 9.14125 20.8588 4.375 15 4.375Z",
    fill: "#28B17B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 6.25C14.4825 6.25 14.0625 5.83 14.0625 5.3125V0.9375C14.0625 0.42 14.4825 0 15 0C15.5175 0 15.9375 0.42 15.9375 0.9375V5.3125C15.9375 5.83 15.5175 6.25 15 6.25Z",
    fill: "#28B17B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.0625 15.9375H24.6875C24.17 15.9375 23.75 15.5175 23.75 15C23.75 14.4825 24.17 14.0625 24.6875 14.0625H29.0625C29.58 14.0625 30 14.4825 30 15C30 15.5175 29.58 15.9375 29.0625 15.9375Z",
    fill: "#28B17B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 30C14.4825 30 14.0625 29.58 14.0625 29.0625V24.6875C14.0625 24.17 14.4825 23.75 15 23.75C15.5175 23.75 15.9375 24.17 15.9375 24.6875V29.0625C15.9375 29.58 15.5175 30 15 30Z",
    fill: "#28B17B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.3125 15.9375H0.9375C0.42 15.9375 0 15.5175 0 15C0 14.4825 0.42 14.0625 0.9375 14.0625H5.3125C5.83 14.0625 6.25 14.4825 6.25 15C6.25 15.5175 5.83 15.9375 5.3125 15.9375Z",
    fill: "#28B17B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 18.75C12.9325 18.75 11.25 17.0675 11.25 15C11.25 12.9325 12.9325 11.25 15 11.25C17.0675 11.25 18.75 12.9325 18.75 15C18.75 17.0675 17.0675 18.75 15 18.75ZM15 13.125C13.9662 13.125 13.125 13.9662 13.125 15C13.125 16.0338 13.9662 16.875 15 16.875C16.0338 16.875 16.875 16.0338 16.875 15C16.875 13.9662 16.0338 13.125 15 13.125Z",
    fill: "#28B17B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_254_8195"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAim);
export default __webpack_public_path__ + "static/media/aim.e3d5f767bc174c14f3649c804a96769e.svg";
export { ForwardRef as ReactComponent };